import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-retraite-complementaire-pro',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './assurance-retraite-complementaire-pro.component.html',
  styleUrls: ['./assurance-retraite-complementaire-pro.component.scss']
})
export class AssuranceRetraiteComplementaireProComponent {
  title = 'Assurance Retraite Complémentaire Professionnelle';
  subtitle = '';
  heroImage = 'assets/static_pages_images/rcpro.jpg';
  
  breadcrumbs = [
    { label: 'Professionnels', link: undefined },
    { label: 'Assurance Retraite Complémentaire', link: undefined }
  ];

  prevPage = {
    title: 'Assurance Prévoyance Entreprise',
    link: '/assurance-prevoyance-entreprise'
  };

  nextPage = {
    title: 'Assurance Retraite Complémentaire Entreprise',
    link: '/assurance-retraite-complementaire-entreprise'
  };

  partners = [
    { name: 'GENERALI', logo: 'assets/images/logos/generali-logo.png' },
    { name: 'ALPTIS', logo: 'assets/logos/ALPTIS.PNG' },
    { name: 'SWISSLIFE', logo: 'assets/images/logos/swisslife-logo.png' },
    { name: 'MALAKOFF HUMANIS', logo: 'assets/logos/MALAKOFF.PNG' }
  ];

  constructor(private router: Router) {}

  navigateToContact() {
    this.router.navigate(['/contactez-nous']);
  }
}
